module.exports = __webpack_public_path__ + "img/skull_14_bj.33c5095f.png";